<div class="component-wrapper">
  <div id="label" [class.invalid]="!isRegexValid(input.value)">
    @if (hasValidtor('require')) {
      <span class="reqIcon" [class.invalid]="!isRegexValid(input.value)" id="require" #require > * </span>
    }
    <span>{{label}}</span>
    @if (hasValidtor('info')) {
      <span id="info" #info insTooltip [cfg]="{text: getValidtor('info').displayText, position: {H: 'hCenter', V:'vTop'}, type: 'info'}"> ? </span>
    }
  </div>
  <div id="inputWrapper" [class.invalid]="!isRegexValid(input.value)" [class.filled]="input.value.length > 0" [class.disabled]="disabled">
    <textarea id="input" #input class="input" placeholder="{{placeholder}}" [(ngModel)]="value" [rows]="numberOfLines" [disabled]="disabled" [class.disabled]="disabled"></textarea>
    @if (!isRegexValid(input.value)) {
      <mat-icon class="warningIcon" svgIcon="warning"
        insTooltip [cfg]="{text: getValidtor('input').displayText, position: {H: 'hRight', V:'vBottom'}, type: 'err'}">
      </mat-icon>
    }
  </div>
</div>
